<template>
  <div class="referral">
    <div class="subheading grey--text mt-6 ml-4">
      <h5 v-if="receivedReferrals">
        My referrals[{{ receivedReferrals.totalRecords }}]
      </h5>
    </div>
    <div class="mx-4 my-4">
      <v-tooltip top
        ><template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            @click="copyToClipboard"
            class="primary"
            plain
            >Copy your referral link<v-icon right>
              mdi-content-copy
            </v-icon></v-btn
          ></template
        ><span>Copy Your Link and Let the Hunt Begin!</span></v-tooltip
      >
    </div>

    <div class="mx-1 my-6">
      <v-layout justify-start class="mt-1 pl-1 mb-3">
        <v-tooltip top
          ><template v-slot:activator="{ on, attrs }">
            <v-chip
              v-bind="attrs"
              v-on="on"
              @click="sortBy('level_1')"
              class="ma-2"
              color="#00BFA5"
              label
              text-color="white"
              :disabled="true"
            >
              <v-icon left> mdi-account </v-icon>
              Level 1
            </v-chip> </template
          ><span>Sort by level 1 referrals</span></v-tooltip
        >

        <v-tooltip top
          ><template v-slot:activator="{ on, attrs }">
            <v-chip
              v-bind="attrs"
              v-on="on"
              @click="sortBy('level_2')"
              class="ma-2"
              color="#ffaa2c"
              label
              text-color="white"
              :disabled="true"
            >
              <v-icon left> mdi-account-multiple </v-icon>
              Level 2
            </v-chip> </template
          ><span>Sort by level 2 referrals</span></v-tooltip
        >
        <v-tooltip top
          ><template v-slot:activator="{ on, attrs }">
            <v-chip
              v-bind="attrs"
              v-on="on"
              @click="sortBy('level_3')"
              class="ma-2"
              color="#FF6347"
              label
              text-color="white"
              :disabled="true"
            >
              <v-icon left> mdi-account-group </v-icon>
              Level 3
            </v-chip> </template
          ><span>Sort by level 3 referrals</span></v-tooltip
        >
      </v-layout>
    </div>

    <div class="mx-4 my-2">
      <div v-if="receivedReferrals">
        <div v-if="receivedReferrals.referrals.length === 0">
          <v-alert text dense color="disabled" border="left">
            🤷‍♂️ No referrals yet! Copy Your Link and Let the Hunt Begin!.
          </v-alert>
        </div>
        <div v-else>
          <v-alert
            v-for="referral in receivedReferrals.referrals"
            :key="referral._id"
            border="left"
            colored-border
            :color="getColor(referral.referralSlug)"
            elevation="3"
          >
            <v-layout row wrap
              ><v-flex xs6 sm4 md2 class="pa-2"
                ><div class="caption grey--text">Referral Level</div>
                <div>{{ referral.referralLevel }}</div></v-flex
              ><v-flex xs6 sm4 md2 class="pa-2"
                ><div class="caption grey--text">Username</div>
                <div>{{ referral.referredUsername }}</div></v-flex
              >
              <v-flex xs6 sm4 md2 class="pa-2"
                ><div class="caption grey--text">Amount</div>
                <div>
                  <v-chip small :class="getColor(referral.referralSlug)" dark>{{
                    referral.amount
                  }}</v-chip>
                </div></v-flex
              >
              <v-flex xs6 sm4 md2 class="pa-2"
                ><div class="caption grey--text">Bonus %</div>
                <div>{{ referral.bonus }}</div></v-flex
              >
              <v-flex xs6 sm4 md2 class="pa-2"
                ><div class="caption grey--text">Deposit Status</div>
                <div>
                  <v-chip small :class="getColorStatus(referral.gainStatus)">{{
                    referral.gainStatus
                  }}</v-chip>
                </div></v-flex
              >
              <v-flex xs6 sm4 md2 class="pa-2"
                ><div class="caption grey--text">Joined</div>
                <div>{{ referral.createdAt | niceDate }}</div></v-flex
              >
            </v-layout>
          </v-alert>
          <div class="text-center mt-6">
            <Pagination
              store="referrals"
              collection="referrals"
              action="fetchReferrals"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import Pagination from "@/components/shared/PaginateGlobal";
export default {
  components: { Pagination },
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("referrals/fetchReferrals", 1);
  },
  computed: {
    receivedReferrals() {
      return this.$store.getters["referrals/referrals"];
    },
    receivedUser() {
      return this.$store.getters.getUser;
    },
  },
  filters: {
    niceDate(value) {
      return format(new Date(value), "yyyy-MM-dd h:mm a");
    },
  },
  methods: {
    copyToClipboard() {
      const linkToCopy = `https://app.flybysms.com/signup?referral=${this.receivedUser.referralCode}`; // Replace with your link
      const tempInput = document.createElement("input");
      tempInput.value = linkToCopy;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      // Show a snackbar or other feedback that the link was copied
      // Example: this.$snackbar.open('Link copied to clipboard');
      this.$store.dispatch("referrals/copyReferralLink");
    },
    getColor(referralLevel) {
      // Define your CSS classes based on transaction types
      switch (referralLevel) {
        case "level_1":
          return "level1"; // Define this class in your component's styles
        case "level_2":
          return "level2";
        case "level_3":
          return "level3";
        // ... define other cases
        default:
          return "";
      }
    },
    getColorStatus(status) {
      // Define your CSS classes based on transaction types
      switch (status) {
        case "Complete":
          return "success"; // Define this class in your component's styles
        case "Pending":
          return "info";
        // ... define other cases
        default:
          return "";
      }
    },
    sortBy(prop) {
      this.receivedUser.sort((a, b) => (a[prop] < b[prop] ? -1 : 1));
    },
    sortReferrals(referralSlug) {
      this.sortedReferrals = this.referrals.filter(
        (referral) => referral.referralSlug === referralSlug
      );
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
.row-pointer {
  cursor: pointer;
  color: #2c5282;
}
.custom-card {
  /* Add your additional border radius values */
  border-radius: 20px;
}
</style>
